module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-118.12461f39.svg";